// -----------------------------------------------------------------------------
// PLUGINS/STORY
// -----------------------------------------------------------------------------
import { keymap } from "prosemirror-keymap";
import { history } from "prosemirror-history";
import { baseKeymap } from "prosemirror-commands";
import { dropCursor } from "prosemirror-dropcursor";
import { addListNodes } from "prosemirror-schema-list";
import { Schema } from "prosemirror-model";
import { EditorState } from "prosemirror-state";
import { EditorView } from "prosemirror-view";
// -----------------------------------------------------------------------------
import { paragraph, blockquote, rule, h1, h2, h3, text, image, hard_break, em, link, strong } from "../schema";
import { buildKeymap } from "../plugins/keymap";
import { buildInputRules } from "../plugins/inputrules";
import { menuPlugin } from "../plugins/menu";
import { elmPlugin } from "../plugins/elm";
import items from "../menu/elems";
// -----------------------------------------------------------------------------
export function storyEditor(container, id, doc, app) {
    container.inner.classList.add("df-ed--story");
    const schema = storySchema();
    const config = {
        schema: schema,
        plugins: plugins(container, schema, id, app)
    };
    if (doc) {
        return new EditorView(container.inner, {
            state: EditorState.create({
                doc: schema.nodeFromJSON(doc),
                plugins: config.plugins
            })
        });
    }
    else {
        return new EditorView(container.inner, {
            state: EditorState.create(config)
        });
    }
}
function storySchema() {
    const base = new Schema({
        nodes: {
            doc: { content: "block+" },
            paragraph, blockquote, rule, h1, h2, h3, text, image, hard_break
        },
        marks: { em, link, strong }
    });
    return new Schema({
        nodes: addListNodes(base.spec.nodes, "paragraph block*", "block"),
        marks: base.spec.marks
    });
}
function plugins(containers, schema, id, app) {
    return [
        menuPlugin(containers, menu, false, id, app),
        buildInputRules(schema),
        keymap(buildKeymap(schema)),
        keymap(baseKeymap),
        dropCursor(),
        history(),
        elmPlugin(id, app)
    ];
}
const menu = [
    items.link,
    items.media,
    items.em,
    items.strong,
    items.orderedList,
    items.bulletList,
    items.rule,
    items.blockquote,
    items.paragraph,
    items.h1,
    items.h2,
    items.h3,
];
